<button class="close-button" type="button" (click)="activeModal.dismiss()">
  <em class="cc-icon cc-icon-close" aria-hidden="true"></em>
</button>
<img class="question-mark" alt="question-mark" src="/assets/images/question-mark.png" />
<section i18n>
  <p class="text-content">
    A Dashpivot workspace account already exists using the <strong>@{{ domain }}</strong> domain. By signing
    up you will not gain access to any existing company workspaces.
  </p>
  <br />
  <p class="text-content">Are you sure you want to continue?</p>
</section>

<section class="sm-flex sm-flex-row sm-space-x-2">
  <button
    type="button"
    class="cta-button sm-bg-default-green hover:sm-bg-default-dark-green"
    (click)="createWorkspace()"
    data-test="create-workspace-button"
  >
    <span i18n>Yes, I want my own workspace</span>
  </button>

  <button
    type="button"
    class="cta-button sm-bg-default-red hover:sm-bg-default-dark-red"
    (click)="joinExistingWorkspace()"
    data-test="join-workspace-button"
  >
    <span i18n>No, I need to join an existing workspace</span>
  </button>
</section>
